import React, { PropTypes } from 'react';
import cn from 'classnames';

import './CompactListItem.scss';


export default function CompactListItem({ columns, className }) {
  return (
    <div className={cn('cp-compact-list-item', className)}>
      <div className="item-row">
        {
          columns.map(column => (
            <div className="item-column">{column}</div>
          ))
        }
      </div>
    </div>
  );
}

CompactListItem.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.node).isRequired,
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/shared/CompactListItem/CompactListItem.jsx